import { useState } from 'react';
import AccordionTransition from 'UIComponents/transitions/AccordionTransition';
import { CardGrid } from 'foundations-components/transitional/components/CardGrid';
import CompletedSectionAccordion from './CompletedSectionAccordion';
import TaskViewList from './TaskViewList';
import { useDismissedTaskCards } from '../../../contexts/TaskCardsContext';
import { MAIN_COLUMN_ITEMS_SPACING_PX } from '../../../constants/layoutConstants';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CompletedSection = ({
  errorLoadingTasks,
  onTaskGroupClick,
  onboardingKey
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const dismissedTaskCards = useDismissedTaskCards();
  if (errorLoadingTasks || dismissedTaskCards.length === 0) {
    return null;
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(CompletedSectionAccordion, {
      isExpanded: isExpanded,
      onClick: () => setIsExpanded(!isExpanded)
    }), /*#__PURE__*/_jsx(AccordionTransition, {
      open: isExpanded,
      children: /*#__PURE__*/_jsx(CardGrid, {
        columns: 1,
        gutterSize: MAIN_COLUMN_ITEMS_SPACING_PX,
        children: /*#__PURE__*/_jsx(TaskViewList, {
          onTaskGroupClick: onTaskGroupClick,
          onboardingKey: onboardingKey,
          showDismissedTaskViews: true
        })
      })
    })]
  });
};
export default CompletedSection;